import React from 'react';
import styled from 'styled-components';
import IconButton from 'material-ui/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

const gridPageOptions = [
	{ value: 5, label: 5 },
	{ value: 10, label: 10 },
	{ value: 25, label: 25 }
];

const bulkDownloadPageOptions = [
    { value: 10, label: 10 },
	{ value: 25, label: 25 },
	{ value: 50, label: 50 },
	{ value: 100, label: 100 }
];

const overdueAckPageOptions = [
    { value: 10, label: 10 },
	{ value: 25, label: 25 },
	{ value: 50, label: 50 },
	{ value: 100, label: 100 }
];
const ChangePageLength = styled(({ pageLength = 10, changePageLength, className, gridName }) => {
   
    return (
        <div className={className}>
            <label>Rows per page:</label>
            <select value={pageLength} onChange={e => changePageLength(e.target.value)}>
            {gridName !== 'BulkDownloadResultsGrid' && gridName !== 'overdueAckResultsGrid' &&
                gridPageOptions.map((item)=> <option value={item.value}>{item.value}</option>)
            }{gridName === 'BulkDownloadResultsGrid' &&
            bulkDownloadPageOptions.map((item)=> <option value={item.value}>{item.value}</option> )
               }{gridName === 'overdueAckResultsGrid' &&
               overdueAckPageOptions.map((item)=> <option value={item.value}>{item.value}</option> )
               }
                
            </select>
        </div>
    );
})`
    display: inline-block;
    & label {
        margin-right: 1em;
    }
`;




const pageStart = (currentPage = 0, totalRows = 0, pageLength = 10) =>
    totalRows === 0 ? 0 : (currentPage + 1) * pageLength - pageLength + 1;

const pageEnd = (currentPage = 0, totalRows = 0, pageLength = 10) =>
    totalRows === 0 ? 0 : Math.min(totalRows, (currentPage + 1) * pageLength);

const DisplayedResults = styled(
    ({ currentPage = 0, pageLength = 10, totalRows = 0, className }) => {
        return (
            <span className={className}>
                {pageStart(currentPage, totalRows, pageLength)}-{pageEnd(
                    currentPage,
                    totalRows,
                    pageLength
                )}{' '}
                of {totalRows}
            </span>
        );
    }
)`
    white-space: nowrap;
`;

const ChangePageActions = styled(props => {
    const {
        totalRows,
        pageLength,
        currentPage,
        firstPage,
        previousPage,
        nextPage,
        lastPage,
        className
    } = props;

    const onLastPage = currentPage >= Math.ceil(totalRows / pageLength) - 1;

    return (
        <div className={className}>
            <IconButton onClick={firstPage} disabled={currentPage === 0} aria-label="First Page">
                <FirstPageIcon />
            </IconButton>
            <IconButton
                onClick={previousPage}
                disabled={currentPage === 0}
                aria-label="Previous Page"
            >
                <KeyboardArrowLeft />
            </IconButton>
            <IconButton onClick={nextPage} disabled={onLastPage} aria-label="Next Page">
                <KeyboardArrowRight />
            </IconButton>
            <IconButton onClick={lastPage} disabled={onLastPage} aria-label="Last Page">
                <LastPageIcon />
            </IconButton>
        </div>
    );
})`
    display: flex;
    flex-shrink: 0;
`;

const Pagination = props => {
    const {
        totalRows,
        pageLength,
        changePageLength,
        currentPage,
        firstPage,
        previousPage,
        nextPage,
        lastPage,
        className,
        gridName
    } = props;

    return (
        <div className={className}>
            <ChangePageLength pageLength={pageLength} changePageLength={changePageLength} gridName={gridName}/>
            {/* <ChangePageLengthBulkDownload pageLength={pageLength} changePageLength={changePageLength} /> */}
            <DisplayedResults
                currentPage={currentPage}
                pageLength={pageLength}
                totalRows={totalRows}
                gridName={gridName}
            />
            <ChangePageActions
                totalRows={totalRows}
                pageLength={pageLength}
                currentPage={currentPage}
                firstPage={firstPage}
                previousPage={previousPage}
                nextPage={nextPage}
                lastPage={lastPage}
            />
        </div>
    );
};

export default styled(Pagination)`
    display: flex;
    align-items: center;
    height: 100%;
    font-size: 0.9rem;
    color: #595959;

    & ${ChangePageLength} {
        margin-right: 2em;
    }

    & ${DisplayedResults} {
        margin-right: 1em;
    }
`;
